module.exports = __webpack_public_path__ + "static/media/file_example_MP4_480_1_5MG1959361999.d9061d3d.mp4";